import { render, staticRenderFns } from "./LimitQuery.vue?vue&type=template&id=723a1b78&scoped=true"
import script from "./LimitQuery.vue?vue&type=script&lang=js"
export * from "./LimitQuery.vue?vue&type=script&lang=js"
import style0 from "./LimitQuery.vue?vue&type=style&index=0&id=723a1b78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a1b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('723a1b78')) {
      api.createRecord('723a1b78', component.options)
    } else {
      api.reload('723a1b78', component.options)
    }
    module.hot.accept("./LimitQuery.vue?vue&type=template&id=723a1b78&scoped=true", function () {
      api.rerender('723a1b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TalentQuery/SearchPage/LimitQuery.vue"
export default component.exports